import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the initial state for the coupon (only coupon code)
interface CouponState {
  code: string;
}

const initialState: CouponState = {
  code: '',
};

// Create the slice
const couponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {
    // Action to apply a coupon code
    applyCoupon(state, action: PayloadAction<string>) {
      state.code = action.payload;
    },
    // Action to remove the applied coupon code
    removeCoupon(state) {
      state.code = '';
    },
    // Action to reset the coupon state
    resetCouponState(state) {
      state.code = '';
    },
  },
});

// Export actions and reducer
export const { applyCoupon, removeCoupon, resetCouponState } = couponSlice.actions;
export default couponSlice.reducer;
